import React from 'react'
import { Box, Typography, Grid } from '@mui/material'
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined'
import RecyclingOutlinedIcon from '@mui/icons-material/RecyclingOutlined'
import SupportAgentOutlinedIcon from '@mui/icons-material/SupportAgentOutlined'
import VerifiedOutlinedIcon from '@mui/icons-material/VerifiedOutlined'

const reasons = [
  {
    icon: (
      <LocationOnOutlinedIcon
        fontSize="large"
        sx={{ color: '#57C84D' }}
      />
    ),
    title: 'Local & Responsive',
    description:
      'Operating within a 50-mile radius of Basingstoke, we provide fast response times and a dependable mobile service.',
  },
  {
    icon: (
      <RecyclingOutlinedIcon
        fontSize="large"
        sx={{ color: '#57C84D' }}
      />
    ),
    title: 'Sustainability Focused',
    description:
      'We believe quality pallets should not go to waste. Repairing, reusing and recycling pallets helps reduce landfill and create value.',
  },
  {
    icon: (
      <SupportAgentOutlinedIcon
        fontSize="large"
        sx={{ color: '#57C84D' }}
      />
    ),
    title: 'Personal Service',
    description:
      'When you contact Pulse Pallets, you deal directly with Freddy. From enquiry to delivery, every customer receives a personal service.',
  },
  {
    icon: (
      <VerifiedOutlinedIcon
        fontSize="large"
        sx={{ color: '#57C84D' }}
      />
    ),
    title: 'Quality Assured',
    description:
      'Every pallet is carefully inspected before supply, ensuring reliable products and consistent quality for your business.',
  },
]

const WhyChooseUs = () => (
  <Box
    sx={{
      px: { xs: 3, md: 8 },
      pb: { xs: 4, md: 8 },
      textAlign: 'center',
    }}
  >
    <Typography
      variant="h4"
      sx={{
        fontWeight: 700,
        color: '#ffffff',
        mb: 2,
      }}
    >
      Why Choose Pulse Pallets?
    </Typography>

    <Typography
      sx={{
        color: '#C8C8C8',
        maxWidth: '800px',
        mx: 'auto',
        mb: 4,
        fontSize: '1.1rem',
        lineHeight: 1.8,
      }}
    >
      Pulse Pallets combines personal service, sustainability and quality 
      control to deliver reliable pallet solutions for businesses across 
      Hampshire and the surrounding areas.
    </Typography>

    <Grid
      container
      spacing={5}
      justifyContent="center"
    >
      {reasons.map((reason, index) => (
        <Grid
          item
          xs={12}
          sm={6}
          md={3}
          key={index}
        >
          <Box
            sx={{
              background: '#222023',
              border: '1px solid rgba(87,200,77,0.15)',
              borderRadius: '12px',
              p: 4,
              height: '100%',
              transition: 'all 0.3s ease',

              '&:hover': {
                borderColor: '#57C84D',
                transform: 'translateY(-4px)',
              },
            }}
          >
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                mb: 2,
              }}
            >
              {reason.icon}
            </Box>

            <Typography
              variant="h6"
              sx={{
                fontWeight: 600,
                color: '#ffffff',
                mb: 2,
              }}
            >
              {reason.title}
            </Typography>

            <Box
              sx={{
                width: '60px',
                height: '3px',
                backgroundColor: '#57C84D',
                mx: 'auto',
                mb: 2,
              }}
            />

            <Typography
              sx={{
                color: '#C8C8C8',
                lineHeight: 1.8,
              }}
            >
              {reason.description}
            </Typography>
          </Box>
        </Grid>
      ))}
    </Grid>
  </Box>
)

export default WhyChooseUs